export default "__VITE_ASSET__CC2P767G__"